<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <!-- <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户</label>
            <em class="weui-form-preview__value">{{initData.cu_name}}</em>
          </div>
        </div> -->
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{initData.pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{initData.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{initData.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{initData.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{initData.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料类型</label>
            <span class="weui-form-preview__value">{{initData.pr_kind}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">数量</label>
            <span class="weui-form-preview__value">{{initData.pw_onhand}}{{initData.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">成本单价（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pw_avprice}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">成本金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pw_amount}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  }
};
</script>